import type { TJobPositionSuggest } from 'shared/types';

export const isJobPositionValid = (suggest: TJobPositionSuggest | undefined): suggest is TJobPositionSuggest =>
  !!suggest?.position && !!suggest?.type;

export const mapJobPosition = (
  suggest: NonNullable<TJobPositionSuggest>,
): Dictionaries.TSelectOption<string, NonNullable<TJobPositionSuggest>> => {
  const { position, ...data } = suggest;
  return {
    value: position,
    label: position,
    data: {
      ...data,
      position,
    } as NonNullable<TJobPositionSuggest>,
  };
};

export const mapJobPositions = (
  suggests?: TJobPositionSuggest[],
): Array<Dictionaries.TSelectOption<string, NonNullable<TJobPositionSuggest>>> => {
  return suggests?.filter(isJobPositionValid)?.map(mapJobPosition) ?? [];
};
